// The connection line (scenario M4, INSTALL.md §6 question 3, B-240, B-558):
// a band under the top bar of every screen in the app's frame — every league
// and account screen — while this device cannot reach the site. The screens
// outside the frame (the signed-out front door, About, a join link, the
// start-up screen) show nothing that updates; what they ask the server for
// says "You're offline" itself (`api.ts`).
//
// Being offline is obvious, so a person knows nothing here will update. So
// it says the consequence, not just the state, and it is a solid band across
// the app rather than a pill in a corner: the screen under it keeps what it
// last showed, from this device if need be (B-222, B-557), and the band is
// what says not to trust it to move. Three things to say, because they have
// three different answers (`connection.ts`): no network at all is the
// device's to fix; a network that reaches nothing may be the site's, and has
// Try again; and *Back online* says the screens are catching up. It goes by
// itself, with nothing to dismiss.

import { Icon } from '../kit/Icon';
import { connection, useConnection } from '../data/connection';

export function ConnectionLine() {
  const state = useConnection();
  if (state === 'online') return null;
  if (state === 'back') {
    return (
      <div className="fsp-connection fsp-connection-back" role="status">
        <Icon name="accept" size="sm" />
        <span>
          <strong>Back online.</strong> Catching up now.
        </span>
      </div>
    );
  }
  return (
    <div className="fsp-connection" role="status">
      <Icon name="warning" size="sm" />
      <span className="fsp-connection-words">
        {state === 'offline' ? (
          <>
            <strong>You're offline.</strong> Scores and everything else here won't update until
            you're back.
          </>
        ) : state === 'reconnecting' ? (
          <>
            <strong>Reconnecting…</strong> Scores and everything else here won't update until you're
            back.
          </>
        ) : (
          <>
            <strong>Can't reach the site.</strong> Scores and everything else here won't update
            until it's back.
          </>
        )}
      </span>
      {state === 'unreachable' && (
        <button type="button" className="fsp-connection-retry" onClick={() => connection.retry()}>
          Try again
        </button>
      )}
    </div>
  );
}
